import DatePicker from './DatePicker';
import DateRangePicker from './DateRangePicker';

export { DateRangePicker, DatePicker };
export default DatePicker;



// WEBPACK FOOTER //
// ./src/datePicker/index.js